
export default {
  name: 'FooterLinks',
};
